// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"f5791edf","453":"670e15c7","936":"98d6b27f"}[chunkId] + ".chunk.js";
};